<template>
  <div>
    <div class="sync-tip">
      <div class="tip-content">
        <img
          class="info-icon"
          width="14"
          height="14"
          src="@/assets/svg/icons/alert.png"
        />
        <p class="tip-text">
          Já é usuário(a) 99Empresa? Vincule sua conta de e-mail existente para
          sincronizar dados.
        </p>
      </div>
      <PubbleButton text="Vincular" size="small" @click="handleSync" />
    </div>
    <PebbleModal
      :visible="showVerifyEmailModal"
      title="Insira seu e-mail"
      content="Insira seu e-mail de acesso atual para vincular seus dados anteriores."
      confirmText="Verificar e-mail"
      cancelText="Cancelar"
      @confirm="handleVerifyEmail"
      @cancel="closeVerifyEmailModal"
    >
      <template #content>
        <div class="email-input-container">
          <input
            v-model="emailAddress"
            type="email"
            class="email-input"
            placeholder="Insira o e-mail"
            @input="validateEmail"
          />
          <div v-if="emailError" class="error-text">{{ emailError }}</div>
        </div>
      </template>
    </PebbleModal>
  </div>
</template>

<script>
import email from '@/services/email'
import PebbleModal from '@/components/PebbleModal.vue'
import PubbleButton from '@/components/PubbleButton.vue'
import { mapActions } from 'vuex'
export default {
  name: 'SyncEmail',
  props: {
    phoneCountryCode: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showVerifyEmailModal: false,
      emailAddress: '',
      emailError: ''
    }
  },

  components: {
    PebbleModal,
    PubbleButton
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),
    async handleSync () {
      this.showVerifyEmailModal = true
    },

    validateEmail () {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!this.emailAddress) {
        this.emailError = 'Insira o e-mail'
      } else if (!emailRegex.test(this.emailAddress)) {
        this.emailError = 'Formato de e-mail inválido'
      } else {
        this.emailError = ''
      }
    },

    async handleVerifyEmail () {
      this.validateEmail()
      if (this.emailError || !this.emailAddress) {
        return
      }
      try {
        const response = await email.sendVerifyEmail({
          email_address: this.emailAddress
        })
        const { errno, errmsg } = response || {}
        if (errno === 0) {
          this.showAlert({
            type: 'success',
            message:
              'O e-mail de verificação foi enviado. Use o link enviado no e-mail para concluir a verificação'
          })
        } else {
          this.showAlert({
            type: 'error',
            message: errmsg
          })
        }
        this.closeVerifyEmailModal()
      } catch (error) {
        console.error('Failed to send verify email:', error)
        this.showAlert({
          type: 'error',
          message: 'Ocorreu um erro, tente novamente mais tarde'
        })
      }
    },

    closeVerifyEmailModal () {
      this.showVerifyEmailModal = false
      this.emailAddress = ''
      this.emailError = ''
    }
  }
}
</script>

<style scoped>
.sync-tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #f8f8fa;
  border-radius: 8px;
  margin: 20px 0;
  gap: 12px;
}

.tip-content {
  display: flex;
  gap: 9px;
}

.info-icon {
  width: 14px;
  height: 14px;
  transform: translateY(3px);
}

.tip-text {
  font-family: DiDiSans-Pro-Medium;
  font-size: 14px;
  color: #16161a;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 500;
  margin: 0;
}

.email-input-container {
  margin-top: 16px;
}

.email-input {
  width: 100%;
  height: 32px;
  padding: 5px 12px;
  border: 1px solid #d2d2d9;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}

.email-input:focus {
  border-color: #16161a;
}

.error-text {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
</style>
